import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useFetch from '../hooks/useFetch';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faA, faComment, faEnvelope, faFileAlt, faInfoCircle, faLink, faMicrophone, faMicrophoneAlt, faPhone, faPhoneVolume, faTag, faTimesCircle, faUser, faUsers, faVolumeHigh, faVolumeLow, faVolumeTimes, faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faLinkedin, faTwitter, faWhatsapp} from '@fortawesome/free-brands-svg-icons';
import { faGlobe, faBriefcase, } from '@fortawesome/free-solid-svg-icons';
import QRCode from 'react-qr-code';
import logo from '../assets/logo.png';
import "../styles/MyProfile.css";
import adImage from '../assets/pageimages/bookshelflisted.webp';


const FortyFiveDigitalCard = () => {
  const [fetchData] = useFetch();
  const navigate = useNavigate();

  const { code } = useParams(); 
  const [think5whysCode, setThink5whysCode] = useState(code);
  const [profileData, setProfileData] = useState({
    userCode: code,
    name: '',
    gender: 0,
    dob: '',
    email: '',
    mobile: '',
    city: '',
    institution: '',
    socialLinks: '',
    personalPageLink: '',
    image: '',
    isSpeakig: false,
    speakTest: 'Welcome to Think5Whys Blue Digital Card',
    speakLang: 'en-US',
    isVideo: false,
    videoURL: ''
  });
  const [profileExists, setProfileExists] = useState(false);
  const [profileId, setProfileId] = useState('');
  const [loading, setLoading] = useState(true);
  const [createSuccessMsg, setCreateSuccessMsg] = useState('');

  useEffect(() => {
    document.title = "Think5Whys Blue Digital Card";
  }, [think5whysCode]);

  useEffect(() => {
    fetchUserProfile();
  }, [think5whysCode]);

  

  const fetchUserProfile = useCallback(() => {
    const config = {
      url: `/pub/blue/${think5whysCode}`,
      method: 'get',
    };

    // console.log(config);

    fetchData(config)
      .then(response => {
        if (response && response.status) {
          const { blueProfile } = response;
          // console.log(blueProfile);
          setProfileExists(true);
          setProfileId(blueProfile._id);
          setProfileData({
            name: blueProfile.name,
            gender: blueProfile.gender,
            dob: blueProfile.dob,
            email: blueProfile.email,
            mobile: blueProfile.mobile,
            city: blueProfile.city,
            institution: blueProfile.institution,
            socialLinks: blueProfile.socialLinks,
            personalPageLink: blueProfile.personalPageLink,
            think5whysCode: blueProfile.think5whysCode,
            bloodGroup: blueProfile.bloodGroup,
            emergencyContact: blueProfile.emergencyContact, 
            isAvailable: blueProfile.isAvailable, 
            availableForWork: blueProfile.availableForWork, 
          });
          document.title = `Think5Whys Blue Digital Card - ${blueProfile.name}`;
        } else {
          setCreateSuccessMsg("Sorry! Blue Profile Not Found. Please retry.");
        }
      })
      .catch(error => {
        console.error("Error getting blue profile:", error);
        setCreateSuccessMsg("Sorry! Blue Profile Not Found. Please retry.");
      })
      .finally(() => setLoading(false)); 
  }, [think5whysCode]);

  const origin = window.location.origin;
  const qrValue = `${origin}/pub/blue/${think5whysCode}`;

  if (loading) {
    return <p>Loading...</p>;
  }

  const handleCloseClick = () => {

    // navigate(-1);
  };

  const handleIconClick = (action) => {
    // console.log(`${action} icon clicked`);
    // Implement specific action later
  };



  return (
    <div className="flex flex-col justify-center items-center p-4 relative">
      {/* Main Profile Card */}
      <div className="bg-gradient-to-r from-blue-500 to-blue-800 border border-gray-600 rounded-lg shadow-lg w-full max-w-sm p-4 relative">
        <div className="flex justify-center mb-4 relative">
          <img 
            src={`/api/downloads/users/profilepic/${profileData.think5whysCode}.png`} 
            alt="Profile Pic" 
            className="w-32 h-32 rounded-full border-4 border-yellow-400"
          />
          { profileData.isAvailable && (
            <>
            {/* SVG for Text Along Path */}
            <svg className="absolute w-40 h-40 top-0 left-30" viewBox="0 0 100 100">  
              <defs>
                <path id="circlePath" d="M 50,52 m -45,0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0" />
              </defs>
              <text fontSize="10" fill="orange" fontWeight="bold">
                <textPath href="#circlePath" startOffset="25%" textAnchor="middle">
                  I am available Now
                </textPath>
              </text>
            </svg>
            </>
            )}
        </div>
        
        <div className="flex flex-col flex-wrap justify-center mt-8 mb-2">
          { profileData.isAvailable && (
              <p className="text-sm text-white mb-1 text-center">{profileData.availableForWork}</p>
          )}
          <h2 className="text-yellow-200 font-bold text-2xl mb-2 text-center">{profileData.name}</h2>
          <p className="text-sm text-white mb-1 text-center">{profileData.think5whysCode}</p>
          <p className="text-sm text-white mb-1 text-center">{profileData.bloodGroup}</p>
          <p className="text-sm text-white mb-1 text-center">{profileData.institution}</p>
          <p className="text-sm text-white mb-1 text-center">{profileData.email}</p>
          <p className="text-sm text-white mb-1 text-center">{profileData.mobile}</p>
          <p className="text-sm text-white mb-4 text-center">{profileData.city}</p>
        </div>
        {/* Social Links */}
        {/* <div className="flex justify-around mb-4">
          <a href={profileData.socialLinks?.facebook} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="text-blue-600" icon={faFacebook} size="lg" />
          </a>
          <a href={profileData.socialLinks?.instagram} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="text-pink-600" icon={faInstagram} size="lg" />
          </a>
          <a href={profileData.socialLinks?.twitter} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="text-blue-400" icon={faTwitter} size="lg" />
          </a>
          <a href={profileData.personalPageLink} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="text-blue-700" icon={faLinkedin} size="lg" />
          </a>
          <a href={profileData.personalPageLink} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="text-white" icon={faLink} size="lg" />
          </a>
        </div> */}

        {/* QR Code */}
        <div className="bg-black border-4 border-white rounded-lg mt-2 p-4 w-full max-w-sm flex flex-col justify-center items-center">
          <QRCode value={qrValue} size={128} className="bg-white p-2 rounded-md shadow-md mb-2"/>
          {/* <a href={qrValue} target="_blank" rel="noopener noreferrer" className='text-xs flex flex-wrap items-center'>
            {qrValue}
          </a> */}
        </div>

        <div className="mt-4 flex justify-center flex-col items-center">
          <img src={adImage} alt="Ad Image" className="max-w-full max-h-full"/>
          <p className="text-white text-center text-sm py-2 rounded-md mt-2">
            Powered by <img src={logo} alt="Think5Whys" className="inline-block w-6 h-6 mx-2"/> think5whys.com
          </p>
        </div>

        {/* Powered By
        <div className="rounded-lg mt-2 p-4 w-full max-w-sm flex flex-col justify-center items-center">
          <p className="text-red-700 text-center text-sm py-2 rounded-md mt-2">
            Powered by <img src={logo} alt="Think5Whys" className="inline-block w-6 h-6 mx-2"/> think5whys.com
          </p>
        </div> */}

        {/* Left-side Overlay Icons */}
        <div className="absolute top-0 right-0 h-full flex flex-col items-start space-y-3 pr-2 justify-start" style={{ top: '10px', left: '10px' }}>
          <a href={"https://www.think5whys.com"} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="text-red-600" icon={faTimesCircle} size="lg" title="www.thing5whys.com"/>
          </a>
          {/* <a href={profileData.socialLinks?.facebook} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="text-blue-600" icon={faFacebook} size="lg" title="Facebook"/>
          </a>
          <a href={profileData.socialLinks?.instagram} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="text-pink-600" icon={faInstagram} size="lg" title="Instagram"/>
          </a>
          <a href={profileData.socialLinks?.twitter} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="text-white" icon={faTwitter} size="lg" title="X"/>
          </a> */}
          <a href={profileData.personalPageLink} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="text-white" icon={faLinkedin} size="lg" title="Change Language"/>
          </a>
          {/* <a href={profileData.personalPageLink} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="text-gray-600" icon={faLink} size="lg" title="Personal Page"/>
          </a> */}
          <a href={profileData.mobile} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="text-white" icon={faPhone} size="lg" title="Call"/>
          </a>
          <a href={profileData.email} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="text-white" icon={faEnvelope} size="lg" title="Email"/>
          </a>
          <a href={profileData.mobile} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="text-white" icon={faWhatsapp} size="lg" title="WhatsApp"/>
          </a>
        </div>

        {/* Right-side Overlay Icons */}
        <div className="absolute top-0 right-0 h-full flex flex-col items-center space-y-3 pr-2 justify-start" style={{ top: '10px', right: '1px' }}>
        <FontAwesomeIcon 
            icon={faA} 
            size="lg" 
            className="text-white hover:text-gray-600 cursor-pointer" 
            onClick={() => handleIconClick('Language')} 
            title="Change Language"
          />
          <FontAwesomeIcon 
            icon={faBriefcase} 
            size="lg" 
            className="text-white hover:text-gray-600 cursor-pointer" 
            onClick={() => handleIconClick('What We Do')}
            title="We Do" 
          />
          <FontAwesomeIcon 
            icon={faTag} 
            size="lg" 
            className="text-white hover:text-gray-600 cursor-pointer" 
            onClick={() => handleIconClick('Products')} 
            title="Products/Services"
          />
          <FontAwesomeIcon 
            icon={faComment} 
            size="lg" 
            className="text-white hover:text-gray-600 cursor-pointer" 
            onClick={() => handleIconClick('Testimonials')} 
            title="Customer Testimonials"
          />
          <FontAwesomeIcon 
            icon={faUsers} 
            size="lg" 
            className="text-white hover:text-gray-600 cursor-pointer" 
            onClick={() => handleIconClick('Customers')} 
            title="Customer List"
          />
          <FontAwesomeIcon 
            icon={faInfoCircle} 
            size="lg" 
            className="text-white hover:text-gray-600 cursor-pointer" 
            onClick={() => handleIconClick('More Info')} 
            title="More Info"
          />
          <FontAwesomeIcon 
            icon={faFileAlt} 
            size="lg" 
            className="text-white hover:text-gray-600 cursor-pointer" 
            onClick={() => handleIconClick('Bio')} 
            title="Bio/About"
          />
          <FontAwesomeIcon 
            icon={faVolumeLow} 
            size="lg" 
            className="text-white hover:text-gray-600 cursor-pointer" 
            onClick={() => handleIconClick('Audio Pitch')} 
            title="Audio Pitch"
          />
          <FontAwesomeIcon 
            icon={faVolumeHigh} 
            size="lg" 
            className="text-white hover:text-gray-600 cursor-pointer" 
            onClick={() => handleIconClick('Audio Story 2')} 
            title="Details"
          />
        </div>
      </div>
    </div>

  );
};

export default FortyFiveDigitalCard;
